<template>
  <div class="main">
    <div class="logo">
      <img :src="appInfo.appLogo" alt="" />
    </div>
    <div class="box">
      <div class="title">
        <img
          v-if="platform == 'ios'"
          src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/IOS.png"
          alt=""
        />
        <img
          v-else
          src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/android.png"
          alt=""
        />
        <h2>{{ appInfo.name }}</h2>
      </div>

      <div class="dec">
        <p>平台：{{ platform }} 版本：{{ appEditionLog.title }}</p>
        <p>更新时间：{{ appEditionLog.updateTime }}</p>
      </div>
    </div>
    <div class="help" @click="showGuide = true">
      <img
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/help.png"
        alt=""
      />安装指引
    </div>
    <div class="download">
      <van-button
        v-if="showBtn"
        type="info"
        round
        class="btn"
        @click="handleDownLoad"
        :loading="loading"
        loading-type="spinner"
        loading-text="加载中..."
        >点击安装</van-button
      >

      <div class="change" v-else>
        <p>
          正在下载安装<br />安卓用户请在浏览器中查看下载进度<br />苹果用户请在手机桌面查看进度
        </p>

        <h3>如遇到下载安装问题请点击下面的按钮进行反馈</h3>
        <van-button
          type="primary"
          round
          class="btn"
          @click="showFeedback = true"
          >立即反馈</van-button
        >
      </div>
    </div>
    <div class="toast" v-if="isWeixin">
      <img
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/app_download_pop.png"
        alt=""
      />
    </div>
    <van-popup v-model="showGuide" closeable round close-icon="close">
      <div class="ios" v-if="platform == 'ios'">
        <video
          controls
          src="https://pc.derucci.net:3100/app-download/video/iphone.mp4"
        ></video>
      </div>
      <div class="guide" v-else>
        <img
          :src="item"
          v-for="(item, index) in appInfo.guide"
          :key="index"
          alt=""
        />
      </div>
    </van-popup>
    <van-popup v-model="showFeedback" closeable round position="bottom">
      <van-form @submit="onSubmit" style="padding-top: 25px">
        <van-field
          v-model="phone"
          name="phone"
          label="联系方式"
          placeholder="请填填写您的联系方式"
          maxlength="20"
          :error="false"
          :rules="[{ required: true, message: '请填填写您的联系方式' }]"
        />
        <van-field
          v-model="feedback"
          name="description"
          label="问题描述"
          placeholder="请填填写您要反馈的问题"
          type="textarea"
          autosize
          rows="3"
          maxlength="500"
          show-word-limit
          :error="false"
          :rules="[{ required: true, message: '请填填写您要反馈的问题' }]"
        />
        <van-field name="uploader" label="截图上传">
          <template #input>
            <van-uploader v-model="uploader" />
          </template>
        </van-field>
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { isIos } from "@/utils/";
//submitFeedbackFile
// import { uploadFiles, submitFeedback } from "@/api/common";
// import { Toast } from "vant";

export default {
  name: "AppMain",
  data() {
    return {
      showBtn: true,
      platform: isIos ? "ios" : "android",
      isWeixin: !!/MicroMessenger/i.test(window.navigator.userAgent),
      showGuide: false,
      loading: false,
      showFeedback: false,
      feedback: "",
      phone: "",
      uploader: [],
    };
  },
  props: {
    appInfo: {
      type: Object,
      default: () => ({
        name: "营销助手APP下载",
        appLogo:
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/mlogo.png",
        guide: [],
      }),
    },
    appEditionLog: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    downloadUrl() {
      const { plistUrl, androidUrl } = this.appEditionLog;
      return this.$route.query.plat === "ios" || isIos
        ? "itms-services://?action=download-manifest&url=" +
            encodeURIComponent(plistUrl)
        : androidUrl;
    },
  },
  created() {
    this.platform = this.asIOS() ? "ios" : "android";
  },
  methods: {
    asIOS() {
      return this.$route.query.plat === "ios" || isIos;
    },
    async onSubmit() {
      //5d4ce0b3-db28-4aec-abb8-36022bcd5763
      // const files = new FormData();
      // form.uploader.map((item) => {
      //   files.append("dataFiles", item.file);
      // });
      // const { list } = await uploadFiles(files);
      // submitFeedback({
      //   phone: form.phone,
      //   description: form.description,
      //   appName: this.appInfo.name,
      //   userAgent: navigator.userAgent,
      //   key: "a0fad19d-b565-4a0b-964d-dbdd66415c29",
      //   imgs: list.map((item) => item.url),
      // }).then(() => {
      //   (this.showFeedback = false), (this.feedback = ""), (this.uploader = []);
      //   Toast.success("提交成功！");
      // });
    },
    handleDownLoad() {
      // const clickName = isIos ? "ios下载" : "android下载";
      // eslint-disable-next-line
      // _hmt.push(["_trackEvent", clickName, this.appInfo.name, "点击"]);
      location.href = this.downloadUrl;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.showBtn = false;
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  background: url(https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/bar.png)
    center top no-repeat;
  background-size: 100% auto;
  overflow: hidden;
  padding-bottom: 50px;
  .guide {
    width: 90vw;
    height: 90vh;
    overflow: scroll;
    img {
      width: 100%;
    }
  }
  .ios {
    width: 90vw;
    height: 90vh;
    overflow: hidden;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .toast {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    img {
      width: 100%;
    }
  }
  .help {
    padding-top: 40px;
    padding-bottom: 40px;
    font-size: 14px;
    color: #999;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      padding-right: 5px;
    }
  }
  .download {
    text-align: center;
    p {
      color: #1abc9c;
      font-size: 14px;
    }
    h3 {
      padding-top: 20px;
      font-size: 15px;
      font-weight: normal;
      padding-bottom: 10px;
      color: #999;
    }
    .btn {
      width: 200px;
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .box {
    padding-top: 80px;
    .dec {
      color: #969b9d;
      font-size: 14px;
      text-align: center;
      //    padding-bottom: 80px;
    }
    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      justify-content: center;
      padding-bottom: 30px;
      h2 {
        font-weight: normal;
        padding: 0 10px;
        font-size: 24px;
      }
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
  .logo {
    height: 160px;
    width: 160px;
    border-radius: 50%;
    box-shadow: 0px 0px 30px rgb(231, 231, 231);
    margin: 130px auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
